import React, { useEffect, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getProviderProjects,
  getProviderWarehouses,
  getProviderItemCategories,
  getProviderItems,
  getProviderProvinces,
  getProviderFacilities,
} from "store/provider-dashboard/provider-dashboard-action"
import MEReportComponent from "components/ProviderReports/MEReport"
import {
  getMEReport,
  exportMEReport,
} from "store/provider-reports/p-report-action"

const ProviderMEReport = () => {
  // Meta Title
  document.title = "M&E Report"

  const dispatch = useDispatch()

  // Retrieve M&E report data from Redux store
  const meReport = useSelector(state => state.providerReports.meReport)
  const exportME = useSelector(state => state.providerReports.exportMEReport)

  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [advancedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn } = useReportColumns(
    REPORT_COLUMN_KEYS.PROVIDER_ME_RECEIPTS
  )

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(getMEReport(link.url, pageNumber, search, advancedSearch))
  }

  // Updates the number of rows displayed based on user selection
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Fetch new data based on page number changes
  useEffect(() => {
    dispatch(getMEReport(undefined, pageNumber, search, advancedSearch))
  }, [pageNumber])

  // Fetch data for filters
  useEffect(() => {
    dispatch(getProviderProjects())
    dispatch(getProviderWarehouses())
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderFacilities())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getMEReport(undefined, pageNumber, search, data))
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportMEReport(pageNumber, search, advancedSearch, visibleKeys))
  }

  // Store Item Categories and fetch items based on item category
  const onCategoryChange = category => {
    dispatch(getProviderItems(category))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"M&E Report"} />
      {/* M&E Report Component */}
      <MEReportComponent
        data={meReport?.data}
        error={meReport?.error}
        loading={meReport?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportME={exportME}
        onPageClick={onPageClick}
        onCategoryChange={onCategoryChange}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
      />
    </React.Fragment>
  )
}

export default ProviderMEReport
